import z from 'zod';
import { tokenSchema } from '@core/schemas/tokenService.schema';
import { USER_STATUSES, USER_TYPES } from '@shared/constants/user.constant';
import { permissionsSchema } from '@shared/schemas/permissionService.schema';
import { emailSchema } from './auth.schema';

const loginSchema = z.object({
  tokens: tokenSchema,
  user: z.object({
    id: z.string(),
    name: z.string(),
    username: z.string().optional(),
    email: emailSchema.nullable().optional(),
    status: z.enum([USER_STATUSES.active, USER_STATUSES.invited]),
    type: z.enum([USER_TYPES.user, USER_TYPES.api_user, USER_TYPES.anonymous]),
    createdAt: z.iso.datetime().optional(),
    lastActivityAt: z.iso.datetime().nullable().optional(),
    roles: z.array(z.string()),
    permissions: permissionsSchema
  })
});

const abcloudzLoginCredentialsSchema = z.object({
  clientId: z.string(),
  refreshToken: z.string().nullable().optional()
});

const abcloudzLoginSchema = loginSchema;

export { loginSchema, abcloudzLoginCredentialsSchema, abcloudzLoginSchema };
